function getProductTag(tag, locale) {
    if (!tag) return null;
    return {
        key: tag.key,
        value: typeof tag.value == 'string' ? tag.value : tag.value[locale]
    };
}

export { getProductTag };
//# sourceMappingURL=get-product-tag.js.map
